 import { createSlice } from "@reduxjs/toolkit";
import { fetchOrderHistory } from "./apiThunk";

const initialState = {
  orderHistory: [],
};

const orderHistorySlice = createSlice({
  name: "orderHistory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrderHistory.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchOrderHistory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.orderHistory = action.payload.data || [];
      })
      .addCase(fetchOrderHistory.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

const {
  reducer,
} = orderHistorySlice;

const selectorOrderHistory = (state) => state.orderHistory;

export { selectorOrderHistory };

export default reducer;
